// import { BaseQueryArg } from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import { IFoundProductData } from '../../model/IFoundProduct'
import { IImport } from '../../model/IImport'
import { IImportFormFullProduct, IImportFormProduct } from '../../model/IImportForm'
import { IImportStatistics } from '../../model/IImportStatistics'
import { TImportsFilterState } from '../store/importsSlice'
import api from './api'
import { IApiPagable, IPagableRequest } from './IPagable'

export interface IAddImportProductsResponse {
  count: number
}

export const importApi = api.injectEndpoints({
  endpoints: (build) => ({
    addImportProducts: build.mutation<IAddImportProductsResponse, IImportFormFullProduct[]>({
      query: (body) => ({
        url: '/import',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['imports', 'import-statistics'],
    }),

    findProduct: build.query<IFoundProductData, IImportFormProduct>({
      query: ({ productId, company }) => ({
        url: '/import/find-product',
        params: {
          productId,
          company,
        },
      }),
    }),

    getStatistics: build.query<IImportStatistics, unknown>({
      query: () => ({
        url: '/import/statistics',
      }),
      providesTags: ['import-statistics'],
    }),

    getImportsMerge: build.query<IApiPagable<IImport[]>, IPagableRequest<TImportsFilterState>>({
      query: (params) => ({
        url: '/import',
        params,
      }),
      providesTags: ['imports'],
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName
      },
      merge: (currentCache, newItems, { arg }) => {
        if ((arg?.page || 0) > 1) currentCache.content.push(...newItems.content)
        else return newItems
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg !== previousArg
      },
    }),

    getTrackingImportsMerge: build.query<
      IApiPagable<IImport[]>,
      IPagableRequest<TImportsFilterState>
    >({
      query: (params) => ({
        url: '/import/update-tracking-list/history',
        params,
      }),
      providesTags: ['tracking-imports'],
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName
      },
      merge: (currentCache, newItems, { arg }) => {
        if ((arg?.page || 0) > 1) currentCache.content.push(...newItems.content)
        else return newItems
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg !== previousArg
      },
    }),

    getActualTrackingImports: build.query<IImport[], unknown>({
      query: () => ({
        url: '/import/update-tracking-list/actual',
      }),
      providesTags: ['actual-tracking-imports'],
    }),

    // -- Tracking
    updateTracking: build.mutation<{ count?: number }, unknown>({
      query: () => ({
        url: '/import/update-tracking-list',
        method: 'POST',
      }),
      invalidatesTags: ['actual-tracking-imports'],
    }),

    launchQueue: build.mutation<{ count?: number }, unknown>({
      query: () => ({
        url: '/import/launch-tracking-list',
        method: 'POST',
      }),
      invalidatesTags: ['actual-tracking-imports'],
    }),

    repeatImport: build.mutation<unknown, IImport['idImport']>({
      query: (idImport) => ({
        url: `/import/repeat/${idImport}`,
        method: 'POST',
      }),
      invalidatesTags: ['imports', 'import-statistics'],
    }),

    deleteImports: build.mutation<{ count?: number }, 'all' | 'pending'>({
      query: (mode) => ({
        url: `/import/${mode}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['imports', 'import-statistics'],
    }),

    // test: build.mutation<any, unknown>({
    //   query: () => ({
    //     url: '/sse/emit',
    //     method: 'POST',
    //   }),
    // }),
  }),
})
